import type { HelpDownloadConfig } from './walkthroughTypes';

// CB:BEGIN help-download-config
export const helpDownloads: HelpDownloadConfig[] = [
  {
    role: 'homeowner',
    pdfUrl: undefined,
    pptxUrl: '/help/downloads/homeowner-walkthrough.pptx',
    status: 'live',
    label: 'Homeowner walkthrough',
  },
  {
    role: 'contractor',
    pdfUrl: undefined,
    pptxUrl: '/help/downloads/contractor-walkthrough.pptx',
    status: 'live',
    label: 'Contractor walkthrough',
  },
];
// CB:END help-download-config

export const getHelpDownloadByRole = (role: HelpDownloadConfig['role']) =>
  helpDownloads.find((entry) => entry.role === role);

